import { render, staticRenderFns } from "./PendingContractsList.vue?vue&type=template&id=6731a6e8&scoped=true&lang=pug&"
import script from "./PendingContractsList.vue?vue&type=script&lang=js&"
export * from "./PendingContractsList.vue?vue&type=script&lang=js&"
import style0 from "./PendingContractsList.vue?vue&type=style&index=0&id=6731a6e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6731a6e8",
  null
  
)

export default component.exports